module.exports = __webpack_public_path__ + "static/media/landing@2x.e7f06e41.mov";